/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    // 公司
    centralizedManagementCompanyId: {},
    centralizedEquipmentType: {}
  },
  getters: {
    // 公司
    centralizedManagementCompanyId: state => state.centralizedManagementCompanyId,
    centralizedEquipmentType: state => state.centralizedEquipmentType
  },
  mutations: {
    centralizedManagementCompanyId: (state, data) => {
      state.centralizedManagementCompanyId = data
    },
    centralizedEquipmentType: (state, data) => {
      state.centralizedEquipmentType = data
    }
  },
  actions: {
    handleCentralizedManagementCompanyId (centralizedManagementCompanyId, data) {
      centralizedManagementCompanyId.commit('centralizedManagementCompanyId', data)
    },
    handleCentralizedEquipmentType (centralizedEquipmentType, data) {
      centralizedEquipmentType.commit('centralizedEquipmentType', data)
    }
  }
}
